// RegisterStep6.js
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import React, { useRef, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { updateStepData } from '../../Store/Actions/Partner';

import { useMediaQuery } from 'react-responsive';

import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';
import { Skeleton } from 'primereact/skeleton';

import Cards from 'react-credit-cards-2';

import Grid from '@mui/material/Grid';

import { 
  maskCardNumber,
  detectCardBrand,
  disableBodyScroll, 
  enableBodyScroll
 } from '../../Components/Utils';


const RegisterStep6 = (props) => {

  const {  
    stepIndex, 
    stepData, 
    stepDataAll, 
    updateStepData,
    stepValidations 
  } = props;

 // console.log('stepDataAll STEP 6----------->'+JSON.stringify(stepDataAll,null,2));

  const formDataRef = useRef({});
  const [formFields, setFormFields] = useState({
    acceptTerms: stepData?.acceptTerms || false
  });

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const [showPrivacyDialog, setShowPrivacyDialog] = useState(false);
  const [showUsageDialog, setShowUsageDialog] = useState(false);
  const [privacyContent, setPrivacyContent] = useState('');
  const [usageContent, setUsageContent] = useState('');

  const [loadingPrivacy, setLoadingPrivacy] = useState(false);
  const [loadingUsage, setLoadingUsage] = useState(false);

  const handleFieldChange = (fieldName, value) => {
    const updated = { ...formFields, [fieldName]: value };
    formDataRef.current = updated;
    setFormFields(updated);
    updateStepData(stepIndex, updated);
  };

  const redirections = stepDataAll?.[4]?.redirections || {};
  const services = stepDataAll?.[1]?.servicesOfferedFull || [];
  const creditCardLater = stepDataAll?.[4]?.creditCardLater;
  const companyAddress = stepDataAll?.[2] || {};
  const card = stepDataAll?.[4] || {};
  const billingAddressSameAsBusiness = card.billingAddressSameAsBusiness;
  const billingAddress = billingAddressSameAsBusiness ? companyAddress : card.billingAddress || {};
  

  const redirectionTable = useMemo(() => {
    
    const currentServiceIds = services.map(s => s.id);
    
    return services
      .filter(service => {
        // Garante que o redirection ainda existe e é válido
        const id = service.id;
        return redirections.hasOwnProperty(id);
      })
      .map((service) => {

        const id = service.id;
        const quantity = redirections[id] || 0;
        const unitPrice = service.lead?.[0]?.perLeadPrice || 30;
        const servicePriceOf = service.lead?.[0]?.servicePriceOf || 'R$ 0,00';
        const servicePriceFor = service.lead?.[0]?.servicePriceFor || 'R$ 0,00';
        const discountPercentage = service.lead?.[0]?.discountPercentage || 0;

        return {
          name: service.name,
          quantity,
          unitPrice,
          total: quantity * unitPrice,
          servicePriceOf,
          servicePriceFor,
          discountPercentage
        };
      });

  }, [services, redirections]);
  
  
  
  const totalRedirections = useMemo(() => {
    return redirectionTable.reduce((acc, item) => acc + item.quantity, 0);
  }, [redirectionTable]);


  const openPrivacyDialog = async () => {
    setShowPrivacyDialog(true);      // Abre o modal imediatamente
    setLoadingPrivacy(true);         // Ativa o loading
    disableBodyScroll(); // 🛑 bloqueia scroll da página
    try {
      const res = await fetch('https://estacaodoolho.kindle.com.br/wp-json/wp/v2/pages/3');
      const json = await res.json();
      setPrivacyContent(json.content.rendered);
    } catch (error) {
      console.error('Erro ao buscar Política de Privacidade:', error);
      setPrivacyContent('<p>Erro ao carregar conteúdo. Tente novamente mais tarde.</p>');
    } finally {
      setLoadingPrivacy(false);      // Finaliza o loading
    }
  };
  
  const openUsageDialog = async () => {
    setShowUsageDialog(true);
    setLoadingUsage(true);
    disableBodyScroll(); // 🛑 bloqueia scroll da página
    try {
      const res = await fetch('https://estacaodoolho.kindle.com.br/wp-json/wp/v2/pages/550');
      const json = await res.json();
      setUsageContent(json.content.rendered);
    } catch (error) {
      console.error('Erro ao buscar Termos de Uso:', error);
      setUsageContent('<p>Erro ao carregar conteúdo. Tente novamente mais tarde.</p>');
    } finally {
      setLoadingUsage(false);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {/* Redirecionamentos */}
      <Panel header="Quantidade de direcionamentos" style={{ marginBottom: '20px', border: 0 }}>
        <div className="leadBox">
          <div className="leadConfig w100 flex-row justify-between tableTitle align-items-center" style={{ padding: '0.5rem 0' }}>
            <div className="flex-1 tAlignL tableTitle">Quantidade de direcionamentos</div>
            <div className="tAlignR tableTitle">Valor por direcionamento</div>
          </div>

          {redirectionTable.map((item, idx) => { /*console.log('item>>>>>>>>>>>>>>>> '+JSON.stringify(item,null,2));*/ return (
            <div key={idx} className="leadConfig w100 flex-row justify-between align-items-center" style={{ padding: '0.5rem 0', borderBottom: '1px solid #e6e6e6' }}>
              <div className="serviceQuantity flex-1 tAlignL">
                {item.quantity > 0 ? `${item.quantity} direcionamentos de` : "Nenhum direcionamento de"} <br /> {item.name} <br />
                <small className="fLight">Valor a ser cobrado do cliente de: <strike>{item.servicePriceOf}</strike> por: {item.servicePriceFor} </small>
              </div>
              <div className="priceTag tAlignR">
                R$ {Number(item.unitPrice).toFixed(2).replace('.', ',')}
              </div>
            </div>
          )}
          )}

          <div className="redirectSummary w100 flex-row justify-between align-items-center tableFooter" style={{ padding: '0.5rem 0', marginTop: '1rem' }}>
            <div className="flex-1 tAlignL tableFooter">Total máximo de direcionamentos</div>
            <div className="tAlignR tableFooter"><strong>{totalRedirections} direcionamentos</strong></div>
          </div>

          <div className="redirectSummary w100 flex-row justify-between align-items-center tableFooter" style={{ padding: '0.5rem 0', marginTop: '1rem' }}>
            <div className="flex-1 tAlignL tableFooter">Total máximo de investimento / mês <br /><small>se conectar com todos os direcionamentos</small></div>
            <div className="tAlignR tableFooter"><strong>R$ {redirectionTable.reduce((acc, item) => acc + item.total, 0).toFixed(2)}</strong></div>
          </div>    

            <div className="redirectSummary w100 flex-row justify-between align-items-center tableFooter" style={{ padding: '0.5rem 0' }}>
              <div className="flex-1 tAlignL tableFooter" style={{fontWeight:"normal"}}>
                Total máximo de faturamento / mês <br />
                <small>se converter todos os direcionamentos</small>
              </div>
              <div className="tAlignR tableFooter" style={{fontWeight:"normal"}}>
                  R$ {
                    redirectionTable.reduce((acc, item) => {
                      const price = parseFloat((item.servicePriceFor || '0').replace(/[^\d,]/g, '').replace(',', '.')) || 0;
                      return acc + (price * item.quantity);
                    }, 0).toFixed(2).replace('.', ',')
                  }
              </div>
            </div>          

        </div>
      </Panel>

      {/* Cartão */}
      <Panel header="Resumo do cartão escolhido" style={{ marginBottom: '20px', border: 0 }}>
        <div className="leadBox">
          <Grid container spacing={2} style={{maxWidth:"100%",padding:"1rem"}}>
            {creditCardLater ? (
              <Grid item xs={12}>
                <div className="warningText">
                  <i className="pi pi-exclamation-triangle" style={{ marginRight: '0.5rem', color: '#fbc02d' }}></i>
                  Você optou por preencher os dados do cartão depois. Você não poderá receber direcionamentos até que cadastre um cartão de crédito.
                </div>
              </Grid>
            ) : (
              <>
              <div className={isMobile ? "w100 flex-column justify-center align-items-center" : "w100 flex-row justify-between align-items-center"} style={{ padding: '0.5rem 0' }}>
                
                <div className="flex-1">
                  <Grid container spacing={2} className="infoBlock">
                    <Grid item xs={12}>
                      <div className="tAlignL label">Número do cartão:</div>
                      <div className="tAlignL value">
                          {card.cardNumber
                            ? maskCardNumber(card.cardNumber)
                            : '**** **** **** ****'}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className="tAlignL label">Nome no cartão:</div>
                      <div className="tAlignL value">{card.cardHolderName || 'Nome do Titular Impresso no Cartão'}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className="tAlignL label">Data de expiração:</div>
                      <div className="tAlignL value">{card.cardExpiry || '00/00'}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className="tAlignL label">CPF do proprietário:</div>
                      <div className="tAlignL value">{card.cardHolderCpf || '000.000.000-00'}</div>
                    </Grid> 
                  </Grid>
                </div>

                <div className={isMobile ? "mT1rem" : ""}>
                  <Cards
                    number={maskCardNumber(card.cardNumber)}
                    name={card.cardHolderName || ''}
                    expiry={card.cardExpiry || ''}
                    cvc={card.cardCvc || ''}
                    focused="number"
                    locale={{ valid: 'VALIDADE' }}
                    placeholders={{ name: 'NOME DO TITULAR' }}
                    style={{ width: '100%', maxWidth: '400px', marginTop: '1rem' }}
                  />
                </div>

              </div>

              </>
            )}
          </Grid>
        </div>
      </Panel>

      {/* Faturamento */}
      <Panel header="Dados de faturamento" style={{ marginBottom: '20px', border: 0 }}>
        <div className="leadBox">
          <Grid container spacing={2} className="infoBlock">

            {billingAddressSameAsBusiness && (
              <Grid item xs={12}>
                <div className="warningText">
                  <i className="pi pi-exclamation-triangle" style={{ marginRight: '0.5rem', color: '#fbc02d' }}></i>
                  Você optou por usar o mesmo endereço do negócio para faturar o serviço. 
                </div>
              </Grid>)
            }

            <Grid item xs={12} className="flex-row justify-between align-items-center">
              <div className="tAlignL label flex-1">CNPJ de faturamento:</div>
              <div className="tAlignR value flex-1_5">{card.billingDocument || '00.000.000/0000-00'}</div>
            </Grid>
            {!billingAddressSameAsBusiness && (
              <>
                <Grid item xs={12} className="flex-row justify-between align-items-center">
                  <div className="tAlignL label flex-1">Endereço:</div>
                  <div className="tAlignR value flex-1_5">
                    {billingAddress.address || ''}, {billingAddress.number || ''} {billingAddress.complement || ''}
                  </div>
                </Grid>
                <Grid item xs={12} className="flex-row justify-between align-items-center">
                  <div className="tAlignL label flex-1">Bairro:</div>
                  <div className="tAlignR value flex-1_5">{billingAddress.neighborhood || ''}</div>
                </Grid>
                <Grid item xs={12} className="flex-row justify-between align-items-center">
                  <div className="tAlignL label flex-1">Cidade / UF:</div>
                  <div className="tAlignR value flex-1_5">{billingAddress.city || ''} / {billingAddress.uf || ''}</div>
                </Grid>
              </>
            )}
            {billingAddressSameAsBusiness && (
              <>
                <Grid item xs={12} className="flex-row justify-between align-items-center">
                  <div className="tAlignL label flex-1">Endereço:</div>
                  <div className="tAlignR value flex-1_5">
                    {billingAddress?.address || ''}, {billingAddress?.number || ''} {billingAddress?.complement || ''}
                  </div>
                </Grid>
                <Grid item xs={12} className="flex-row justify-between align-items-center">
                  <div className="tAlignL label flex-1">Bairro:</div>
                  <div className="tAlignR value flex-1_5">{billingAddress?.neighborhood || ''}</div>
                </Grid>
                <Grid item xs={12} className="flex-row justify-between align-items-center">
                  <div className="tAlignL label flex-1">Cidade / UF:</div>
                  <div className="tAlignR value flex-1_5">{billingAddress?.city || ''} / {billingAddress?.uf || ''}</div>
                </Grid>
              </>
            )}            
          </Grid>
        </div>
      </Panel>

      {/* Aceite de Termos */}
      <Panel header="Aceite os termos para finalizar" style={{ border: 0 }}>
        <div className="tAlignL formControl flex-row align-items-center" style={{ gap: '0.5rem' }}>
          <Checkbox
            inputId="acceptTerms"
            checked={formFields.acceptTerms}
            onChange={(e) => handleFieldChange('acceptTerms', e.checked)}
          />
          <label style={{ marginBottom: 0 }}>
            Concordo com a <span className="clickableLink" onClick={openPrivacyDialog} style={{textDecoration:"underline",cursor:"pointer"}}>Política de Privacidade</span> e com os <span className="clickableLink" onClick={openUsageDialog} style={{textDecoration:"underline",cursor:"pointer"}}>Termos de Uso</span>
          </label>
        </div>
      </Panel>

      {/* Modal: Política de Privacidade */}
      <Dialog
        header="Política de Privacidade"
        visible={showPrivacyDialog}
        style={{ width: isMobile ? '90vw' : '70vw', maxWidth: '800px', height:"70vh" }}
        onHide={() => {setShowPrivacyDialog(false); enableBodyScroll();}}
        closeOnEscape={()=>enableBodyScroll()}
        modal
      >
        {loadingPrivacy ? (
          <div style={{ padding: '2rem' }}>
            <Skeleton width="60%" height="2rem" style={{ marginBottom: '1rem' }} /><br />
            <Skeleton width="100%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
            <Skeleton width="95%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
            <Skeleton width="90%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
            <Skeleton width="85%" height="1rem" />
          </div>
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: privacyContent }}
          />
        )}
      </Dialog>


      {/* Modal: Termos de Uso */}
      <Dialog
        header="Termos de Uso"
        visible={showUsageDialog}
        style={{ width: isMobile ? '90vw' : '50vw', maxWidth: '800px', height:"70vh" }}
        onHide={() => {setShowUsageDialog(false); enableBodyScroll();}}
        closeOnEscape={()=>enableBodyScroll()}        
        modal
      >
        {loadingUsage ? (
          <div style={{ padding: '2rem' }}>
            <Skeleton width="60%" height="2rem" style={{ marginBottom: '1rem' }} /><br />
            <Skeleton width="100%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
            <Skeleton width="95%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
            <Skeleton width="90%" height="1rem" style={{ marginBottom: '0.5rem' }} /><br />
            <Skeleton width="85%" height="1rem" />
          </div>
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: usageContent }}
          />
        )}
      </Dialog>


    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  stepData: state.partnerReducer.stepData[ownProps.stepIndex],
  stepDataAll: state.partnerReducer.stepData
});

const mapDispatchToProps = {
  updateStepData
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStep6);
